<template>
  <div>
    <h1>{{ $t("settings.userSubstitute.substitutesList") }}</h1>

    <v-row style="margin-bottom: 15px">
      <v-col cols="3">
        <v-text-field v-model="search" append-icon="search" :label="$t('global.search')" single-line hide-details></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <div>
        <user-substitute-form @saved="load">
          <v-btn color="accent" block>{{ $t("settings.userSubstitute.addNewSubstitute") }}</v-btn>
        </user-substitute-form>
      </div>
    </v-row>
    <v-data-table :headers="headers" :items="userSubstitutes" :search="search">
      <template #item="props">
        <tr>
          <td class="text-left">{{ props.item.absent_user_name }}</td>
          <td class="text-left">{{ props.item.absent_login }}</td>
          <td class="text-left">{{ props.item.substitute_user_name }}</td>
          <td class="text-left">{{ props.item.substitute_login }}</td>
          <td class="text-left">{{ props.item.from_date }}</td>
          <td class="text-left">{{ props.item.to_date }}</td>
          <td class="text-left">{{ props.item.comment }}</td>
          <td class="text-center text-no-wrap">
            <user-substitute-form :userSubstitute.sync="props.item" @saved="load" />
            <v-tooltip bottom>
              {{ $t("global.delete") }}
              <template #activator="{on}">
                <v-btn v-on="on" @click.native="remove(props.item)" icon>
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import UserSubstituteForm from "../../components/Settings/UserSubstituteForm.vue";

export default {
  name: "UserSubstituteList",
  components: { UserSubstituteForm },
  data: () => ({
    search: "",
    userSubstitutes: []
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t("settings.userSubstitute.fields.absentUser.name"),
          value: "absent_user_name"
        },
        {
          text: this.$t("settings.userSubstitute.absentUserLogin"),
          value: "absent_login"
        },
        {
          text: this.$t("settings.userSubstitute.fields.substituteUser.name"),
          value: "substitute_user_name"
        },
        {
          text: this.$t("settings.userSubstitute.substituteUserLogin"),
          value: "substitute_login"
        },
        {
          text: this.$t("settings.userSubstitute.fields.fromDate.name"),
          value: "from_date"
        },
        {
          text: this.$t("settings.userSubstitute.fields.toDate.name"),
          value: "to_date"
        },
        {
          text: this.$t("settings.userSubstitute.fields.comment.name"),
          value: "comment"
        },
        { text: this.$t("global.actions"), sortable: false, value: "actions", align: "center" }
      ];
    }
  },
  created() {
    this.load();
  },
  methods: {
    remove(item) {
      let dialog = this.$store.dispatch("confirmDialog", {
        content: this.$t("settings.userSubstitute.removeConfirmDialog.content"),
        title: this.$t("settings.userSubstitute.removeConfirmDialog.title")
      });
      dialog.then(() => {
        this.axios.post("settings/user-substitute/item-delete", { id: item.id }).then(() => {
          this.load();
          this.$store.dispatch("AUTH_UPDATE_SETTINGS").then(() => {
            this.$store.dispatch("snackbarPush", {
              text: this.$t("settings.userSubstitute.removeConfirmDialog.snackbar"),
              position: "down"
            });
          });
        });
      });
    },
    load() {
      this.axios.get("settings/user-substitute/list").then(resp => {
        this.userSubstitutes = resp.data;
      });
    }
  }
};
</script>

<style scoped></style>
